import { useUserRole as _useUserRole } from '@lucid/auth';

// Re-export shared constants and types so app consumers keep the same import path.
export { USER_ROLES } from '@lucid/auth';
export type { UseUserRoleResult } from '@lucid/auth';

/**
 * Portal-bound wrapper around `useUserRole` from `@lucid/auth`.
 * Binds the Auth0 roles namespace from the Vite environment so callers
 * don't need to pass it explicitly.
 *
 * @component
 * @returns `{ isAdmin, isImporter, isImporterAR, isAgencySales, isARSupportAgent, roles, isLoading }`
 */
export const useUserRole = () => _useUserRole(`https://${import.meta.env.VITE_AUTH0_DOMAIN}/roles`);
